import { useState, useEffect } from 'react';
import api from './api';

const DEFAULT_SITE_CONTENT = {
    hero_subtitle: "A GLOBAL CHRISTIAN FILM",
    hero_title: "GAWAH",
    hero_witness: "Witness",
    hero_tagline1: "The story didn't end with Sadhu Sundar Singh.",
    hero_tagline2: "It continued through two ordinary people who chose extraordinary obedience.",
    hero_cta_trailer: "WATCH TRAILER",
    hero_cta_subscribe: "SUBSCRIBE FOR FULL MOVIE",
    story_title: "A legacy that refused to stay buried",
    story_p1: "Sadhu Sundar Singh disappeared into the Himalayas in 1929, and with him, the world assumed, went the last chapter of his story. But history often forgets the sequel.",
    story_p2: "His nephew Sadhu Kishan Singh and his niece Shanta Kaur chose to leave comfort behind and follow the same Christ their uncle had given everything for. Their journey carried them into danger, opposition, sickness and moments that had no earthly explanation. Entire villages encountered the Gospel because two people decided obedience was worth the cost. Many found faith. Some paid dearly for it.",
    story_p3: "GAWAH – The Witness is the film that brings their true story to the screen, based on the book Thunder in the Himalayas by Dr. Babu K. Verghese.",
    story_caption_intro: "And it leaves you with the same question it asks everyone who watches:",
    story_caption_question: "What does wholehearted devotion to Christ actually look like?",
    trailer_title: "Watch the Trailer",
    trailer_youtube_url: "https://www.youtube.com/embed/QzMejuo6WDA",
    about_title: "The GAWAH Media Project",
    about_p1: "Gawah Media is an organization of filmmakers, writers, artists, producers, and media professionals united by a shared mission: to communicate the timeless message of hope, truth, and faith through powerful storytelling.",
    about_p2: "Beyond content creation, Gawah Media is committed to building a vibrant ecosystem for faith-based media. We actively seek collaborations with creators, production partners, distributors, broadcasters, streaming platforms, and organizations across the world to ensure that these stories reach audiences everywhere.",
    about_p3: "Our vision is to become a global hub for the development, production, distribution, and promotion of impactful media that carries the Good News with artistic excellence, authenticity, and cultural relevance.",
    about_p4: "At Gawah Media, we don't simply create content—we create stories that leave a lasting impact.",
    footer_copyright: "© 2026 GAWAH Media. All rights reserved."
};

export function useSiteContent() {
    const [content, setContent] = useState(DEFAULT_SITE_CONTENT);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        api.get('site-content/')
            .then(res => {
                if (isMounted && res.data && typeof res.data === 'object') {
                    setContent(prev => ({ ...prev, ...res.data }));
                }
            })
            .catch(err => {
                console.log("Could not load backend site settings, using defaults:", err.message);
            })
            .finally(() => {
                if (isMounted) setLoading(false);
            });

        return () => { isMounted = false; };
    }, []);

    const getContent = (key, fallback = '') => {
        return content[key] !== undefined && content[key] !== null && content[key] !== ''
            ? content[key]
            : (DEFAULT_SITE_CONTENT[key] || fallback);
    };

    return { content, getContent, loading };
}
